
import { holdingsAdditionalDetails, holdingsForWatchlist } from "../../apis";
import { _getEquityHoldingScrips, _getScripsInfo } from "../../controllers";
import { deepClone, getApiExchangeNameFromMktSegId, getMktSegIdFromMappedMktSegId } from "../../utils/global_functions";
import { NETWORK_RESPONSE_STATUS } from "../../utils/global_variables";
import { HOLDINGS } from "../actionTypes";


export const getHoldingsData = (user_id, groupId) => async (dispatch) => {
    try {
        const objresp = await dispatch(getHoldingsForWatchlist());

        return new Promise(resolve => {
            resolve(objresp);
        });
    } catch (error) {
        dispatch(getHoldingsFailure([]));

        console.log(error);
    }
};

export const getHoldingsColumnDef = () => async (dispatch) => {
    try {

        const holdingColumnProfile = [
            {
                field: "sSymbol",
                headerName: "SYMBOL",
                filter: "agNumberColumnFilter",
                hide: false,
                nSequenceNo: 1
            },
            {
                field: "qty",
                headerName: "QTY",
                filter: "agNumberColumnFilter",
                hide: false,
                nSequenceNo: 2
            }, {
                field: "ltp",
                headerName: "LTP",
                filter: "agNumberColumnFilter",
                hide: false,
                nSequenceN: 3
            },
            {
                field: "nBuyAvgPriceDisplay",
                headerName: "AVG. PRICE",
                filter: "agNumberColumnFilter",
                hide: false,
                nSequenceNo: 4
            },
            {
                field: "InvestedValue",
                headerName: "INVESTED AMT",
                filter: "agTextColumnFilter",
                hid: false,
                nSequenceNo: 5
            },
            {
                field: "CMV",
                headerName: "CURRENT VALUE",
                filter: "agNumberColumnFilter",
                hide: false,
                nSequenceNo: 6
            }, {
                field: "TodaysPandL",
                headerName: "TODAY'S PL",
                filter: "agTextColumnFilter",
                hide: false,
                nSequenceNo: 7
            },
            {
                field: "perTodaysPandL",
                headerName: "TODAY'S PL%",
                filter: "agTextColumnFilter",
                hide: false,
                nSequenceNo: 8
            },
            {
                field: "PandL",
                headerName: "OVERALL PL",
                filter: "agTextColumnFilter",
                hide: false,
                nSequenceNo: 9
            }, {
                field: "perPandL",
                headerName: "OVERALL PL%",
                filter: "agNumberColumnFilter",
                hide: false,
                nSequenceNo: 10
            },
        ];
        dispatch(updateHoldingsColdef(holdingColumnProfile));
    } catch (error) {
        console.log(error);
    }
};
export const updateHoldingsColdef = (payload) => {
    return { type: HOLDINGS?.UPDATE_HOLDINGS_COLUMN_DEF, payload };
};


export const updateWatchlistGridIndexHoldings = (payload) => {
    return { type: HOLDINGS?.UPDATE_WATCHLIST_GRID_CONVERTED_HOLDINGS_SCRIPS, payload };
};

export const updateHoldingsScrips = (payload) => {
    return { type: HOLDINGS.UPDATE_HOLDINGS_SCRIPS, payload };
};

export const getHoldingsForWatchlist = () => async (dispatch, getState) => {
    let payload;
    try {
        const objLoginSession = deepClone(getState().auth?.objLoginSession);

        const objresp = await holdingsForWatchlist(payload = { user_id: objLoginSession?.data?.user_id, groupId: objLoginSession?.data?.others?.groupId });
        const objrespAdditionalDetails = await holdingsAdditionalDetails({ user_id: objLoginSession?.data?.user_id, groupId: objLoginSession?.data?.others?.groupId });
        let arrAdditionalHoldingsDetails = objrespAdditionalDetails?.data?.result?.map(item => ({ ...item, sCurcvPledge: 0, sRecvPledge: 0 }));

        // Azeem K : 22-02-2024 : BT-102298  BSEEQ Portfolio Holdings  – Start
        for (let i = 0; i < objresp?.data?.result?.length; i++) {
            objresp.data.result[i].nMarketSegmentId = getMktSegIdFromMappedMktSegId(objresp.data.result[i].nMarketSegmentId);
        }
        // Azeem K : 22-02-2024 : BT-102298  BSEEQ Portfolio Holdings  – End 

        const arrUniqueScrips = [];
        const seenCombination = {};
        objresp?.data?.result?.forEach(element => {
            const segmentAndToken = `${element.nMarketSegmentId}-${element.nToken}`;
            if (!seenCombination[segmentAndToken]) {
                seenCombination[segmentAndToken] = true;
                arrUniqueScrips.push({ mkt: getApiExchangeNameFromMktSegId(element?.nMarketSegmentId), token: element.nToken });
            }
        });
        let objScripsResp = await _getScripsInfo(arrUniqueScrips);
        if (objresp?.status) {
            let updatedResp = objresp?.data?.result;
            updatedResp?.forEach((eachResp, i) => {
                const updatedObjScripsResp = objScripsResp?.data?.objScripsResp?.result;
                // Azeem K : 22-02-2024 : BT-102298  BSEEQ Portfolio Holdings  – Start 
                let nIndex = updatedObjScripsResp?.findIndex((eachScrip) => (eachResp?.nMarketSegmentId + '_' + eachResp?.nToken === eachScrip?.MktSegId + '_' + eachScrip?.nToken));
                // Azeem K : 22-02-2024 : BT-102298  BSEEQ Portfolio Holdings  – End 
                if (nIndex >= 0) {
                    updatedResp[i].ScripData = [updatedObjScripsResp[nIndex]];
                } else { }
                let objAdditionalDetails = arrAdditionalHoldingsDetails?.find((item) => item?.ISIN === eachResp?.ISIN);
                if (objAdditionalDetails) {
                    updatedResp[i] = {  ...objAdditionalDetails,...updatedResp[i] };
                }
            });
            // Azeem K : 22-02-2024 : BT-102298  BSEEQ Portfolio Holdings  – Start 
            dispatch(updateHoldingsScrips(updatedResp));
            // Azeem K : 22-02-2024 : BT-102298  BSEEQ Portfolio Holdings  – End 
        }
        else { }
        return new Promise(resolve => {
            resolve(objresp);
        }
        );
    } catch (error) {
        dispatch(getHoldingsFailure([]));

        console.log(error);
    }
};




export const updateHoldingsType = (payload) => {

    return { type: HOLDINGS.UPDATE_HOLDINGS_TYPE, payload: payload };
};




export const getHoldingsAdditionalDetails = (isin) => async (dispatch, getState) => {
    try {
        const objLoginSession = deepClone(getState().auth?.objLoginSession);

        const objresp = await holdingsAdditionalDetails({ user_id: objLoginSession?.data?.user_id, groupId: objLoginSession?.data?.others?.groupId, isin: isin, });
        let arrHoldingsDetails = objresp?.data?.result?.map(item => ({ ...item, sCurcvPledge: 0, sRecvPledge: 0 }));
        let holdingsScrips = [...getState().holdings?.holdingsScrips];
        if (getState().holdings?.holdingsScrips?.length > 0) {
            getState().holdings?.holdingsScrips.map((each) => {
                const nIndexOfHolding = holdingsScrips.findIndex(obj => obj.ISIN === each.ISIN);
                const objadditionalDetails = arrHoldingsDetails.find(obj => obj.ISIN === each.ISIN);
                holdingsScrips[nIndexOfHolding] = { ...holdingsScrips[nIndexOfHolding], ...objadditionalDetails };
            });

            dispatch(updateHoldingsScrips(holdingsScrips));
            return Promise.resolve(holdingsScrips);
        } else {
            dispatch(getHoldingsFailure([]));
            return [];
        }

    } catch (error) {
        dispatch(getHoldingsFailure([]));
        console.log(error);
    }
};

export const getHoldingsSuccess = (payload) => {
    return { type: HOLDINGS.GET_HOLDINGS_SUCCESS, payload: payload };
};

export const getHoldingsFailure = (payload) => {
    return { type: HOLDINGS.GET_HOLDINGS_FAILURE, payload: payload };
};

export const updateActiveHoldings = (payload) => {
    return { type: HOLDINGS.UPDATE_ACTIVE_HOLDINGS, payload };
};

export const getSideBarHoldings = () => async (dispatch, getState) => {

    const objLoginSession = deepClone(getState().auth?.objLoginSession);
    const objHoldingsData = await dispatch(getHoldingsData(objLoginSession?.data?.user_id, objLoginSession?.data?.others?.groupId));

    if (objHoldingsData?.status === NETWORK_RESPONSE_STATUS.SUCCESS) {
        let equityHoldings = objHoldingsData?.data?.result.filter(elem => elem.sSeries === 'EQ');
        let mutualFundsHoldings = objHoldingsData?.data?.result.filter(elem => elem.sSeries === 'MF');
        let holdingTypes = [{ id: 1, name: 'EQUITY', data: [...equityHoldings].map(obj => ({ ...obj, ltp: '' })) }, { id: 2, name: 'Mutual Funds', data: [...mutualFundsHoldings] }];

        dispatch(updateHoldingsType(holdingTypes));
        dispatch(updateActiveHoldings(holdingTypes[0]));
    } else {
        dispatch(updateHoldingsType([]));
        dispatch(updateActiveHoldings({}));
    }

};


export const getHoldingsAdditionalDetailsSuccess = (payload) => {
    return { type: HOLDINGS.GET_HOLDINGS_ADDITIONAL_DETAILS_SUCCESS, payload: payload };
};
export const getHoldingsAdditionalDetailsFailure = (payload) => {
    return { type: HOLDINGS.GET_HOLDINGS_ADDITIONAL_DETAILS_FAILURE, payload: payload };
};

export const getHoldings = () => {
    return { type: HOLDINGS.GET_HOLDINGS, payload: {} };
};




export const getAllHoldingScrips = () => async (dispatch) => {
    try {
        const objMyHoldingWatchlist = await dispatch(getHoldingsForWatchlist());
        const objResp = _getEquityHoldingScrips(objMyHoldingWatchlist);

    } catch (error) {
        dispatch(updateHoldingsScrips([]));
        console.log(error);
    }

};

export const updateHoldingView = (viewtype) => (dispatch) => {
    dispatch(updateHoldingViewSuccess(viewtype));
};

export const updateHoldingViewSuccess = (payload) => {
    return { type: HOLDINGS.UPDATE_HOLDING_VIEW, payload };
};
